import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=b2b7fa36&scoped=true&"
import script from "./IndexPage.vue?vue&type=script&setup=true&lang=js&"
export * from "./IndexPage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./IndexPage.vue?vue&type=style&index=0&id=b2b7fa36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b7fa36",
  null
  
)

export default component.exports